<template>
    <b-row>
        <b-col>
            <div class="custom-control custom-switch mb-3">
                <input class="custom-control-input" type="checkbox" v-model="data.activar_pago_plazos" id="activar_pago_plazos" data-cy="activar-pago-plazos" />
                <label class="custom-control-label pt-1" for="activar_pago_plazos">Activar pago a plazos</label>
            </div>

            <template v-if="data.activar_pago_plazos">
                <b-col cols="12" v-if="frecuencias">
                    <label for="frecuencia">Frecuencia de cargos</label>
                    <ValidationProvider name="Frecuencia de cargos" rules="required" v-slot="{ errors }">
                        <multiselect 
                            data-cy="frecuencia-cargos"
                            placeholder="Frecuencia de cargos"
                            :options="frecuencias"
                            :multiple="true"
                            label="frecuencia_formatted"
                            track-by="id"
                            id="frecuencias"
                            v-model="data.frecuencias"
                        />
                        <span v-if="errors[0]" class="d-block bg-danger text-white mt-1 text-xs" style="padding: 5.5px;">{{ errors[0] }}</span>
                    </ValidationProvider>
                </b-col>
                <div class="d-flex justify-content-between align-items-center mt-4">
                    <b-col cols="6" md="6" xl="6">
                        <FormInput label="Mínimo de plazos" type="number" name="minimo número de plazos" id="min_cantidad_plazos" data-cy="min-cantidad-plazos" rules="required" v-model="data.min_cantidad_plazos" />
                    </b-col>
                    <b-col cols="6" md="6" xl="6">
                        <FormInput label="Máximo de plazos" type="number" name="máximo número de plazos" id="max_cantidad_plazos" data-cy="max-cantidad-plazos" rules="required" v-model="data.max_cantidad_plazos" />
                    </b-col>
                </div>
            </template>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        created() {
            this.getFrecuencias();
        },  
        data() {
            return {
                frecuencias: null,
            }
        },
        computed: {
            lista_id() {
                return this.$store.getters.getListaId;
            }
        },
        methods: {
            getFrecuencias() {
                this.loading = true;

                const data = {
                    lista_id: this.lista_id,
                    filters: {
                        to_select: true 
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('back.frecuencias.index'), data).then(res => {
                    this.frecuencias = res.data.data;
                    this.loading = false;
                });
            },
        }
    }
</script>